module.exports = __webpack_public_path__ + "static/media/patrol(24).c58b8819.PNG";